import React, { useState, useEffect, Fragment } from "react";
import { BrowserRouter as Router, useLocation, useParams } from "react-router-dom";
import "antd/dist/antd.min.css";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useGetStoreSearchQueryQuery } from "../../services/searchs";
import Loader from "../../Components/Loader";
import Button from "@mui/joy/Button";
import SearchLoader from "../../Components/SearchLoader";
import { useGetUserDataQuery } from "../../services/login";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import SeacrhFilter from "../../Components/SeacrhFilter";
import { useMediaQuery } from "react-responsive";
import LoadMoreSkeleton from "../../Components/LoadMoreSkeleton";
import StoreSearchItems from "../../Components/StoreSearchItems";
import { Helmet } from "react-helmet";
import Host from "../../Components/Host";

function StoreSearch() {
  const { userId, userToken, userEmail, languageCode, countryCode } = useSelector((state) => state.auth);
  const location = useLocation();
  const { t } = useTranslation();
  const { storeId } = useParams();
  const limit = new URLSearchParams(location.search).get("size") || 48;
  const searchCountry = new URLSearchParams(location.search).get("country") || null;
  const thisCountry = searchCountry ? `&search_country=${searchCountry}` : "";
  const searchbrand = new URLSearchParams(location.search).get("brand") || null;
  const thisBrand = searchbrand ? `&brand=${searchbrand}` : "";
  const isMobcreen2 = useMediaQuery({ query: "(min-width: 0px) and (max-width: 992px)" });
  const isMobcreen = useMediaQuery({ query: "(min-width: 0px) and (max-width: 768px)" });
  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  const [getProducts, setProductsData] = useState([]);
  const [getPage, setPage] = useState(1);
  const [getSearchId, setSearchId] = useState(0);
  const [getNextCursor, setNextCursor] = useState(0);
  const {
    data: newPosts = [],
    isLoading,
    isError,
    isFetching,
  } = useGetStoreSearchQueryQuery(
    {
      page: getPage,
      size: limit,
      nextCursor: `&nextCursor=${getNextCursor}`,
      store_id: storeId,
      search_id: `&search_id=${getSearchId}`,
      countryCode: countryCode,
      searchCountry: thisCountry,
      searchBrand: thisBrand,
    },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );
  const products = newPosts?.results;
  const pagination = newPosts?.pagination;

  React.useEffect(() => {
    if (products?.length > 0) {
      setProductsData((prevPosts) => [...prevPosts, ...products]);
    }
  }, [newPosts]);

  useEffect(() => {
    if (products) {
      setProductsData(() => [...products]);
      setPage(1);
    }
  }, [storeId, searchCountry]);

  useEffect(() => {
    if (Number(getPage) === 1 && products) {
      setProductsData((prevPosts) => [...products]);
    }
  }, [getPage, products]);

  useEffect(() => {
    if (Number(getPage) === 1 && isFetching) {
      setProductsData((prevPosts) => []);
    }
  }, [getPage, storeId, searchCountry]);

  const lastId = getProducts?.slice(-1)[0]?.id || 0;

  const loadMore = () => {
    setPage((prevPage) => prevPage + 1);
    setSearchId(lastId);
    setNextCursor(pagination?.nextCursor);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  function loadFetch() {
    if (isLoading) {
      return true;
    } else if (isFetching) {
      return true;
    } else {
      return false;
    }
  }

  function nextButton(nextCursor) {
    if (nextCursor) {
      return false;
    } else {
      return true;
    }
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{`${"Store search"} ${"|"} ${Host?.metaTitle}`}</title>
      </Helmet>
      <div className="sp-style">
        <div className="search-section" style={{ position: "relative" }}>
          <div className="container">
            <div className="row">
              {!isMobcreen2 && (
                <SeacrhFilter searchCountry={searchCountry} getProducts={getProducts} isFetching={isFetching} />
              )}

              <div className="col-md-10 mob-w100 mob-p0" style={{ padding: "5px" }}>
                <div className="row">
                  {isLoading && (
                    <div className="col-md-12" style={{ padding: "5px" }}>
                      <div className="sp-search-loader">
                        <div
                          className="sp-query"
                          style={{ fontSize: "1rem", textAlign: "center", display: "flex", alignItems: "center" }}
                        >
                          <span style={{ display: "flex", alignItems: "center" }}>
                            <i className="loader-title">{t("Searching for selected store")}</i>
                          </span>
                          &nbsp;
                          <SearchLoader />
                        </div>
                      </div>
                    </div>
                  )}

                  {!isLoading && (
                    <div style={{ width: "100%", padding: "10px 0px 10px 0px" }}>
                      <div className="search-cardTitle" style={{ textAlign: "start" }}>
                        <div className="search-result-secton">
                          <div className="sp-query" style={{ width: "100%" }}>
                            <span style={{ display: "flex", alignItems: "center" }}>
                              <span className="loader-title">Search results for selected store</span> &nbsp;
                              {loadFetch() && (
                                <span>
                                  <SearchLoader />
                                </span>
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {!isLoading && (
                    <>
                      {!isFetching && (
                        <>
                          {getProducts?.length === 0 && (
                            <div className="no-result-found-secton">
                              <ErrorOutlineOutlinedIcon />
                              <div className="cardTitle">Looks like we couldn't find what you're searching for.</div>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}
                  <>
                    {getProducts?.map((item, i) => (
                      <div className="col-md-3 cardItem" style={{ padding: "5px" }} key={i}>
                        <StoreSearchItems
                          item={item}
                          isFetching={isFetching}
                          languageCode={languageCode}
                          userData={userData}
                        />
                      </div>
                    ))}
                  </>
                  {loadFetch() && <LoadMoreSkeleton />}
                </div>
                <br />
              </div>
              {getProducts?.length > 0 && (
                <div
                  className="search-paginattion"
                  style={{ width: "100%", display: "flex", justifyContent: "center" }}
                >
                  <div style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
                    <Button
                      style={{
                        border: "0.5px solid #39414a",
                        color: "#39414a",
                        fontWeight: 400,
                        height: "40px",
                        margin: "0px 10px",
                      }}
                      disabled={isFetching || nextButton(pagination?.nextCursor)}
                      variant="outlined"
                      onClick={loadMore}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span>{loadFetch() ? "Loading" : t("load_more")}</span>
                        {loadFetch() && (
                          <span style={{ margin: "0px 10px" }}>
                            <Loader />
                          </span>
                        )}
                      </div>
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
    </>
  );
}

export default StoreSearch;
